/*global asset, getCurrencySymbol*/
import _map from 'lodash/map'
import _get from 'lodash/get'
import React, { useCallback } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { checkIsPromoter } from '../../../utils/permissions'
import NumberAnimation from '../../../_library/NumberAnimation'
import { ROLES } from '../../../constants/roles'
import { getPermissions } from '../../../_theme/utils/permissions'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { SET_EVENT_CURRENCY } from '../../../../_common/redux/events/actions'
import _orderBy from 'lodash/orderBy'
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger'
import Tooltip from 'react-bootstrap/lib/Tooltip'

const mapStateToProps = state => ({
  tfRole: _get(state, 'auth.user.tfRole'),
})

export default connect(mapStateToProps, { SET_EVENT_CURRENCY })(
  React.memo(props => {
    const {
      event,
      performanceData,
      influencersData,
      navigateToTab,
      currentTabIndex,
      tfRole,
      SET_EVENT_CURRENCY,
    } = props
    const { carts, sales, addOns, totalSales } = performanceData || {}
    const { statistics, referrers = [] } = influencersData || {}
    const isTicketsInCartsTab = currentTabIndex === 4
    const isPromoter = checkIsPromoter(event)
    const permissions = getPermissions(event?.self?.role)
    const showCurrencySelector = Object.keys(_get(event, 'additionalCurrencies', {})).length > 0
    const selectedCurrency = _get(event, 'selectedCurrency', null)

    // Tickets in Carts data
    const lockedTickets = carts ? carts.total || 0 : 0
    const buyers = carts && carts.buyers ? carts.buyers.length : 0

    // Tickets sales data
    const currencyRebates = _get(
      statistics,
      `breakdown_by_currency.${event?.selectedCurrency ?? null}.refunds_due_without_fee`,
      null,
    )
    const rebatesWithoutFee = currencyRebates ?? (statistics?.refunds_due_without_fee || 0)
    let cumulativeQuantity = 0
    let cumulativeRevenue = 0
    let cumulativeDeposit = 0
    let cumulativeDebt = 0
    let cumulativeGuestRevenue = 0
    let totalCumulativeQuantity = 0

    let cumulativeCashRevenue = 0

    if (!isNil(totalSales) && showCurrencySelector) {
      _map(totalSales || [], row => {
        totalCumulativeQuantity += parseInt(row.quantity)
      })
    }

    _map(sales || [], row => {
      let debt = parseFloat(row.pendingToPay)
      if (isNaN(debt)) {
        debt = 0
      }

      let guestRevenue = parseFloat(row.guestRevenue)
      if (isNaN(guestRevenue)) {
        guestRevenue = 0
      }

      cumulativeQuantity += parseInt(row.quantity)

      if (Number(row.boxOfficePayment)) {
        cumulativeCashRevenue += parseFloat(row.income)
      } else {
        cumulativeRevenue += parseFloat(row.income)
      }
      cumulativeDeposit += parseFloat(row.income) + guestRevenue - debt
      cumulativeDebt += debt
      cumulativeGuestRevenue += guestRevenue
    })

    // calculate add-ons revenue
    _map(addOns || [], addOn => {
      const income = parseFloat(addOn.netRevenue)
      cumulativeRevenue += income
      cumulativeDeposit += income
    })

    const ticketsInCart = useCallback(() => {
      navigateToTab(4)
    }, [navigateToTab])

    const isShownTotalRebats = (tfRole, flagDisableReferral, isPromoter, hasInfluencers) => {
      const hasPerrmission =
        ROLES.is_tf_support(tfRole) || permissions.isAdminOrOwner() || permissions.isStatsOrLimitedStats
      if (!(flagDisableReferral && !hasInfluencers) && hasPerrmission) {
        return true
      }
      return !flagDisableReferral && !isPromoter
    }

    const setActiveCurrency = currencyCode => {
      SET_EVENT_CURRENCY(currencyCode)
    }

    const prepareCurrencyOption = (currency, isDefault) => (
      <div
        aria-hidden
        key={currency.currency}
        className={
          'tab-title' +
          (selectedCurrency === currency.currency || (isNil(selectedCurrency) && isDefault)
            ? ' selected'
            : '')
        }
        onClick={() => setActiveCurrency(currency.currency)}
      >
        {currency.currency}
      </div>
    )

    const getCurrencyOptions = () => {
      const { additionalCurrencies, currency } = event
      let currencyList = Object.keys(additionalCurrencies ?? {})
      currencyList.push(currency?.currency)
      currencyList = _orderBy(currencyList, currency => currency, 'desc')

      return _map(currencyList, currencyCode => {
        let currencyOption = null

        if (currencyCode === currency?.currency) {
          currencyOption = prepareCurrencyOption(currency, true)
        } else {
          currencyOption = prepareCurrencyOption(additionalCurrencies[currencyCode].currency || {})
        }

        return currencyOption
      })
    }

    const displayReleasedToBank = () => (
      <p>
        {event?.flagPaidInAdvance &&
          !!Number(event?.paidInAdvanceAmount) &&
          `${getCurrencySymbol(event)} ${event?.paidInAdvanceAmount} `}
        (Released to bank account&nbsp;
        <img
          src="/resources/images/green-check-mark.svg"
          alt="green check mark"
          style={{
            width: '10px',
            height: '10px',
            padding: 0,
            position: 'static',
            filter: 'unset',
          }}
        />
        &nbsp;)
      </p>
    )

    const displayCartSections = () => (
      <>
        {!isTicketsInCartsTab && (
          <Link to={'/event/' + event.id + '/performance/tickets-in-carts'}>
            <div
              className="tictets-state-title"
              style={{ paddingBottom: 0 }}
              onClick={ticketsInCart}
              aria-hidden="true"
            >
              <div className="value">
                <img
                  src={asset('/resources/images/event/performance/tickets-in-carts-ico.svg')}
                  className="event-stat-ico"
                  alt=""
                />
              </div>
              <div className="title">
                <div className="inner_text">Tickets In Carts</div>
              </div>
            </div>
          </Link>
        )}
        <div className="totalQuantity">
          <div className="value">
            <img src={asset('/resources/images/system_icons/lock-ticket.svg')} alt="" />
            <NumberAnimation duration={1500} target={lockedTickets} localeString={true} linear={true} />
          </div>
          <div className="title">
            <div className={'inner_text'}>Tickets Locked</div>
          </div>
        </div>
        <div className="totalRevenue">
          <div className="value">
            <img src={asset('/resources/images/system_icons/ticket-buyer.svg')} alt="" />
            <NumberAnimation duration={1500} target={buyers} localeString={true} linear={true} />
          </div>
          <div className="title">
            <div className={'inner_text'}>Buyers</div>
          </div>
        </div>
      </>
    )

    const netRevenue = cumulativeRevenue + cumulativeGuestRevenue - rebatesWithoutFee
    const totalNetRevenue = cumulativeCashRevenue + netRevenue

    return !!sales || carts ? (
      <>
        {showCurrencySelector && (
          <>
            <div className="buyerlocation locked-tickets multi-currency-top">
              <div className="rowTotal left-part">
                <div className="totalQuantity">
                  <div className="value">
                    <img src={asset('/resources/images/system_icons/ticket.svg')} alt="" />
                    <NumberAnimation
                      duration={1500}
                      target={totalCumulativeQuantity}
                      localeString={true}
                      linear={true}
                    />
                  </div>
                  <div className="title">
                    <div className={'inner_text'}>Total Tickets Sold</div>
                  </div>
                </div>
                {sales && displayCartSections()}
              </div>
            </div>
            <div className="currencySelector tab-view">
              <div className={`tab-header ${isMobileDevice() ? 'responsive-tab-header' : ''}`}>
                <div style={{ position: 'relative', width: '100%' }}>
                  {' '}
                  <PerfectScrollbar>{getCurrencyOptions()}</PerfectScrollbar>
                </div>
              </div>
            </div>
          </>
        )}
        <div
          className={`buyerlocation locked-tickets ${showCurrencySelector ? 'multi-currency-bottom' : ''}`}
        >
          {!!sales && (
            <div className="rowTotal left-part">
              <div className="totalQuantity">
                <div className="value">
                  <img src={asset('/resources/images/system_icons/ticket.svg')} alt="" />
                  <NumberAnimation
                    duration={1500}
                    target={cumulativeQuantity}
                    localeString={true}
                    linear={true}
                  />
                </div>
                <div className="title">
                  <div className={'inner_text'}>
                    {selectedCurrency && getActiveCurrencySymbol(event) + ` `}Tickets Sold
                  </div>
                </div>
              </div>

              {/* CumulativeDebt == 0 means there isn't at least a table that allows partial deposit */}
              {cumulativeDebt < Number.EPSILON && (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="cumulativeCashRevenue">
                      {`Total Net Revenue: ${getActiveCurrencySymbol(
                        event,
                      )}${totalNetRevenue} (Including ${getActiveCurrencySymbol(
                        event,
                      )}${cumulativeCashRevenue} collected as cash payments)`}
                    </Tooltip>
                  }
                  trigger={cumulativeCashRevenue ? ['hover', 'click'] : []}
                >
                  <div
                    className="totalRevenue"
                    style={{ cursor: cumulativeCashRevenue ? 'pointer' : 'auto' }}
                  >
                    <div className="value">
                      <img src={asset('/resources/images/system_icons/money.svg')} alt="" />
                      <NumberAnimation
                        duration={1500}
                        target={cumulativeRevenue + cumulativeGuestRevenue - rebatesWithoutFee}
                        decimals={2}
                        localeString={true}
                        prefix={getActiveCurrencySymbol(event)}
                        linear={true}
                      />
                    </div>
                    <div className="title">
                      <div className="inner_text">
                        Net Revenue
                        {(event.flagFundsRemitted || event.flagPaidInAdvance) && displayReleasedToBank()}
                      </div>
                    </div>
                  </div>
                </OverlayTrigger>
              )}

              {cumulativeDebt >= Number.EPSILON && (
                <>
                  <div className="totalRevenue">
                    <div className="value">
                      <img src={asset('/resources/images/system_icons/money.svg')} alt="" />
                      <NumberAnimation
                        duration={1500}
                        target={cumulativeDeposit - rebatesWithoutFee}
                        decimals={2}
                        localeString={true}
                        prefix={getActiveCurrencySymbol(event)}
                        linear={true}
                      />
                    </div>
                    <div className="title">
                      <div className={'inner_text'}>Current Deposit</div>
                    </div>
                  </div>

                  <div className="totalRevenue">
                    <div className="value">
                      <img src={asset('/resources/images/system_icons/money.svg')} alt="" />
                      <NumberAnimation
                        duration={1500}
                        target={cumulativeDebt}
                        decimals={2}
                        localeString={true}
                        prefix={getActiveCurrencySymbol(event)}
                        linear={true}
                      />
                    </div>
                    <div className="title">
                      <div className={'inner_text'}>Pending to Pay</div>
                    </div>
                  </div>

                  <div className="totalRevenue">
                    <div className="value">
                      <img src={asset('/resources/images/system_icons/money.svg')} alt="" />
                      <NumberAnimation
                        duration={1500}
                        target={cumulativeRevenue + cumulativeGuestRevenue - rebatesWithoutFee}
                        decimals={2}
                        localeString={true}
                        prefix={getActiveCurrencySymbol(event)}
                        linear={true}
                      />
                    </div>
                    <div className="title">
                      <div className={'inner_text'}>Final Net Revenue</div>
                      {(event.flagFundsRemitted || event.flagPaidInAdvance) && displayReleasedToBank()}
                    </div>
                  </div>
                </>
              )}

              {isShownTotalRebats(tfRole, event.flagDisableReferral, isPromoter, !!referrers.length) && (
                <div className="totalRebates">
                  <div className="value">
                    <img src={asset('/resources/images/system_icons/referral-rebates.svg')} alt="" />
                    <NumberAnimation
                      duration={1500}
                      target={rebatesWithoutFee}
                      decimals={2}
                      localeString={true}
                      prefix={getActiveCurrencySymbol(event)}
                      linear={true}
                    />
                  </div>
                  <div className="title">
                    <div className={'inner_text'}>Referral Rebates</div>
                  </div>
                </div>
              )}
            </div>
          )}
          {carts && !showCurrencySelector && (
            <div className={`rowTotal ${isTicketsInCartsTab ? 'hidden-label' : ''}`}>
              {displayCartSections()}
            </div>
          )}
        </div>
      </>
    ) : null
  }),
)
